import React, { useState } from "react";
import { motion } from "framer-motion";
import type { DiscountDto } from "../utils/api/kolektifOluşumAPI.schemas";

interface DiscountCardProps {
  discount: DiscountDto;
}

export const DiscountCard: React.FC<DiscountCardProps> = ({ discount }) => {
  const [copied, setCopied] = useState(false);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(discount.id.toString());
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      whileHover={{ scale: 1.02 }}
      className="group relative overflow-hidden rounded-2xl bg-[#111111] border border-gray-800 shadow-xl"
    >
      <div className="relative">
        <div className="relative h-48 overflow-hidden">
          <img
            src={discount.logo}
            alt={discount.name}
            className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#111111] to-transparent opacity-60" />
        </div>
        <motion.button
          whileTap={{ scale: 0.95 }}
          onClick={copyToClipboard}
          className={`absolute top-4 right-4 px-4 py-2 rounded-lg backdrop-blur-md font-medium text-sm transition-all duration-300 ${
            copied
              ? "bg-green-500/20 text-green-400 border border-green-500/30"
              : "bg-blue-500/20 text-blue-400 border border-blue-500/30 hover:bg-blue-500/30"
          }`}
        >
          {copied ? "Kopyalandı!" : `KOD: ${discount.id}`}
        </motion.button>
      </div>
      <div className="p-6">
        <h3 className="text-xl font-bold mb-3 text-white">{discount.name}</h3>
        <div className="flex items-center justify-between">
          <div className="px-4 py-2 rounded-lg bg-gradient-to-r from-blue-500/10 to-purple-500/10 border border-blue-500/20 text-blue-400 font-semibold">
            %{discount.discountRate} İndirim
          </div>
          <div className="text-sm text-gray-400">
            {discount.branches.length > 1
              ? `${discount.branches.length} Şube`
              : discount.branches[0]}
          </div>
        </div>
      </div>
    </motion.div>
  );
};
